import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING, EDIT } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_PROJECT,
    StoreType,
    ProjectProps,
    LoadAccountSettings,
    LoadProjectSettings,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    PageForm,
    FormGroup,
    CKEditor,
    Button,
} from "client/components"

const AssumptionView = ({
    projectId = null,
}: ProjectProps) => {
    const baseRoute = useSelector((state: StoreType) => state.silAssumption.baseRoute)
    const reloadView = useSelector((state: StoreType) => state.silAssumption.reloadView)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [assumption, setAssumption] = useState("")

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadAccountSettings(userData.accountId)
        .then((res1) => {
            LoadProjectSettings(projectId)
            .then((res2) => {
                if (res2.sil.assumption) setAssumption(res2.sil.assumption)
                else if (res1.sil.defaultAssumption) setAssumption(res1.sil.defaultAssumption)
                else setAssumption("")
                setLoadState(IDLE)
            })
        })
    }, [reloadView])

    const editUrl = `${baseRoute}/${EDIT}`

    const editAccess = hasAccess(PRM_PROJECT, EDIT)
    const allowedToEdit = editAccess || project.owner === userData.userId

    // view page is always available
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.viewCalculationAssumptions}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <CKEditor
                                    data={assumption}
                                    isReadOnly
                                />
                            </FormGroup>
                            {
                                allowedToEdit && (
                                    <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                        {lang.edit}
                                    </Button>
                                )
                            }
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default AssumptionView
